import { render, staticRenderFns } from "./receivingInfo.vue?vue&type=template&id=2007c91b&scoped=true&"
import script from "./receivingInfo.vue?vue&type=script&lang=js&"
export * from "./receivingInfo.vue?vue&type=script&lang=js&"
import style0 from "./receivingInfo.vue?vue&type=style&index=0&id=2007c91b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007c91b",
  null
  
)

export default component.exports